import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData_Jupiter from "../NoData_Jupiter";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import BuketsTable_Jupiter from "../BuketsTable_Jupiter";
import * as $ from "jquery";

function RangeSecondErc_Jupiter({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "0-60": 0,
      "60-70": 0,
      "70-80": 0,
      "80-90": 0,
      "90-100": 0,
      "100-110": 0,
      "110-120": 0,
      "120-130": 0,
      "130-140": 0,
      "140-150": 0,
      "150-160": 0,
      "160-170": 0,
      "170-180": 0,
      "180-190": 0,
      ">=190": 0,
    };

    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map((d) => {
        // if (
        //   d.discharge_cycle.doc_count > gloablfilter.DISCHARGE &&
        //   (d.deltaOdo.value === 0
        //     ? d.deltaOdo.value >= gloablfilter.DELTA
        //     : d.deltaOdo.value > gloablfilter.DELTA)
        // ) {
        // let value = d.Range.values["50.0"];
        let value = d._source.Range;
        if (value >= 0 && value < 60) {
          responce["0-60"] = responce["0-60"] + 1;
        } else if (value >= 60 && value < 70) {
          responce["60-70"] = responce["60-70"] + 1;
        } else if (value >= 70 && value < 80) {
          responce["70-80"] = responce["70-80"] + 1;
        } else if (value >= 80 && value < 90) {
          responce["80-90"] = responce["80-90"] + 1;
        } else if (value >= 90 && value < 100) {
          responce["90-100"] = responce["90-100"] + 1;
        } else if (value >= 100 && value < 110) {
          responce["100-110"] = responce["100-110"] + 1;
        } else if (value >= 110 && value < 120) {
          responce["110-120"] = responce["110-120"] + 1;
        } else if (value >= 120 && value < 130) {
          responce["120-130"] = responce["120-130"] + 1;
        } else if (value >= 130 && value < 140) {
          responce["130-140"] = responce["130-140"] + 1;
        } else if (value >= 140 && value < 150) {
          responce["140-150"] = responce["140-150"] + 1;
        } else if (value >= 150 && value < 160) {
          responce["150-160"] = responce["150-160"] + 1;
        } else if (value >= 160 && value < 170) {
          responce["160-170"] = responce["160-170"] + 1;
        } else if (value >= 170 && value < 180) {
          responce["170-180"] = responce["170-180"] + 1;
        } else if (value >= 180 && value < 190) {
          responce["180-190"] = responce["180-190"] + 1;
        } else if (value >= 190) {
          responce[">=190"] = responce[">=190"] + 1;
        }
        // }
      });

      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys.map((x) => {
        // res_result_final.push([x, responce[x], "#348393"]);
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;color:#348393",
        ]);
      });
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
      SetApiResponce((prestate) => []);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Range(Km)",
      minValue: 0,
      format: "short",
      textStyle: {
        fontSize: 8, // Adjust the font size as needed
      },
      slantedText: true, // Enable slanted text
      slantedTextAngle: 60, // Rotate labels to vertical (90 degrees)
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Discharge Cycle",
      minValue: 0,
      format: "short",
    },
    // bar: { groupWidth: "90%" },
    bar: { groupWidth: "100%" },
    legend: "none",
    borderRadious: "9px",
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph graph_two p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Jupiter />
          ) : chartdata.length === 0 ? (
            <NoData_Jupiter />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="240px"
              data={chartdata}
              options={options}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default RangeSecondErc_Jupiter;
